// import { ROLES } from '@/constants/roles';

/**
 * Можно удалять весь модуль, потому экспертиза переехала в Poll (задания)
 * Но тут есть компоненты, которые используются в других модулях
 */

const routes = [
  // {
  //   path: '/expertise-criteries',
  //   name: 'expertise-criteries',
  //   component: () => import('./views/ExpertiseCriteries.vue'),
  //   meta: {
  //     title: 'Критерии оценки',
  //     accessList: [ROLES.organization],
  //     instruction: {
  //       id: 35,
  //       name: 'Критерии оценки',
  //     },
  //   },
  // },
  // {
  //   path: '/expertise-criteries/form',
  //   name: 'expertise-form',
  //   component: () => import('./views/ExpertiseAppraisals.vue'),
  //   meta: {
  //     title: 'Критерии оценки',
  //     accessList: [ROLES.organization],
  //     instruction: {
  //       id: 35,
  //       name: 'Критерии оценки',
  //     },
  //   },
  // },
];

export default routes;
